export default __webpack_public_path__ + "static/media/martins_transportadora.8d765666.svg";